import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialOrderFeedbackGuestExperienceState } from './initialState'

const slice = createSlice({
  name: 'orderFeedbackGuestExperience',
  initialState: initialOrderFeedbackGuestExperienceState,
  reducers: {
    setCallTheStoreEnabled: (state, action: PayloadAction<boolean>) => {
      state.callTheStoreEnabled = action.payload
    },
    setAcknowledgmentMessage: (state, action: PayloadAction<string>) => {
      state.acknowledgmentMessage = action.payload
    },
    resetForm: (
      state,
      action: PayloadAction<{
        callTheStoreEnabled: boolean
        acknowledgmentMessage: string
      }>
    ) => {
      state.callTheStoreEnabled = action.payload.callTheStoreEnabled
      state.acknowledgmentMessage = action.payload.acknowledgmentMessage
      state.persistedCallTheStoreEnabled = action.payload.callTheStoreEnabled
      state.persistedAcknowledgmentMessage =
        action.payload.acknowledgmentMessage
    },
    // Marks the current edit as saved. Called after a successful PATCH, which
    // makes the pane clean again and disables Publish until the next change.
    markFormPersisted: state => {
      state.persistedCallTheStoreEnabled = state.callTheStoreEnabled
      state.persistedAcknowledgmentMessage = state.acknowledgmentMessage
    },
    setFormSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isFormSubmitting = action.payload
    },
  },
})

export const reducer = slice.reducer
export const {
  setCallTheStoreEnabled,
  setAcknowledgmentMessage,
  resetForm,
  markFormPersisted,
  setFormSubmitting,
} = slice.actions
